import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';
import { global } from '../Models/global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  ROOT_URL: string = "";
  constructor(private http: Http) {
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
  }

  getInventoryData(requestModel: any): Observable<any> {
    let url = this.ROOT_URL + '/api/Inventory/InventoryData';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: JSON.stringify(requestModel)
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }

  DownloadFile(model: any): Observable<any> {
    let _body = JSON.stringify(model);
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/Inventory/InvExlDownload",
      headers: headers,
      body: _body,
      responseType: ResponseContentType.Blob
    });
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res;
      });
  }
}
